export default {
  getBackup: (state) => state.backup,
};
